"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const stockpile_style_1 = __importDefault(require("../stockpile.style"));
const stockpile_action_1 = __importDefault(require("../stockpile.action"));
const grid_1 = __importDefault(require("components/templates/grid"));
const input_1 = require("components/atoms/input");
const authorization_1 = require("utils/authorization");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const stockpile_column_1 = require("../stockpile.column");
const modal_1 = require("components/molecules/modal");
const svg_1 = require("components/atoms/svg");
const debounces_1 = require("utils/debounces");
const StockpileConfiguration = () => {
    const { dataGrid, dataStates, isLoading, isSuccess, isError, errorMessage, dataDropdown, dataItem, dataBrand } = (0, store_1.useAppSelector)((state) => state.configuration.stockpileConfiguration);
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const debounceCallback = (0, debounces_1.useDebouncedCallback)((newDataStates) => {
        dispatch(stockpile_action_1.default.getDataGrid(newDataStates));
    }, 1000, [dispatch]);
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Configuration', 'Stockpile');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                debounceCallback(dataStates);
                dispatch(stockpile_action_1.default.getDataBrand(dataStates));
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, fullScreen]);
    const iconColor = appTheme === 'dark' ? '#fff' : '#424242';
    const actionCellRender = (0, custom_cell_grid_1.actionCellInline)({
        type: 'other',
        permission: isAuthorized.change,
        iconEdit: (0, jsx_runtime_1.jsx)(svg_1.EditIcon, { color: iconColor }),
        iconSave: (0, jsx_runtime_1.jsx)(svg_1.SaveIcon, { color: iconColor }),
        iconCancel: (0, jsx_runtime_1.jsx)(svg_1.CancelIcon, { color: iconColor }),
        onCancel: (rowItem) => {
            const newDataGrid = dataGrid.map((item) => (Object.assign(Object.assign({}, item), { inEdit: false, isDisabled: false })));
            dispatch(stockpile_action_1.default.onEnterEditClick({ dataBrand, dataItem: rowItem, dataGrid: newDataGrid, mutationMode: false }));
        },
        onSaveItem: () => {
            dispatch(stockpile_action_1.default.onSaveDataItem({ dataItem: dataItem, mutationMode: 'edit', isSuccess: true }));
        },
        onEnterEdit: (rowItem) => {
            const newDataGrid = dataGrid.map((item) => item.checkpoint_id === rowItem.checkpoint_id
                ? Object.assign(Object.assign({}, item), { inEdit: true, isDisabled: false }) : Object.assign(Object.assign({}, item), { inEdit: false, isDisabled: true }));
            dispatch(stockpile_action_1.default.onEnterEditClick({
                dataBrand,
                dataItem: rowItem,
                dataGrid: newDataGrid,
                mutationMode: 'edit',
            }));
        },
    });
    const actionColumn = [
        {
            title: '',
            width: '70px',
            sortable: false,
            filterable: false,
            show: isAuthorized.change,
            cell: actionCellRender,
            locked: true,
        },
    ];
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(stockpile_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(stockpile_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        debounceCallback(newDataStates);
    };
    const onSortChange = (e) => {
        dispatch(stockpile_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        debounceCallback(newDataStates);
    };
    const _getDropdownValue = (field, data) => {
        if (field === 'brand1_name')
            return data.brand1_data || data.brand1_name;
        if (field === 'brand2_name')
            return data.brand2_data || data.brand2_name;
        if (field === 'brand3_name')
            return data.brand3_data || data.brand3_name;
        if (field === 'brand4_name')
            return data.brand4_data || data.brand4_name;
        if (field === 'brand5_name')
            return data.brand5_data || data.brand5_name;
        return '';
    };
    const _getDisableStatus = (field, data) => {
        if (field === 'brand2_name')
            return data.brand2_disable;
        if (field === 'brand3_name')
            return data.brand3_disable;
        if (field === 'brand4_name')
            return data.brand4_disable;
        if (field === 'brand5_name')
            return data.brand5_disable;
        return false;
    };
    const customCellDropdown = ({ dataItem: rowData, dataIndex, field }) => {
        return rowData.inEdit ? ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `m_grid_cell_is_active_${dataIndex}` }, { children: (0, jsx_runtime_1.jsx)(input_1.Dropdown, { name: field, textField: 'name', dataItemKey: 'name', data: dataDropdown, value: _getDropdownValue(field, dataItem), style: stockpile_style_1.default.dropdownStyle(appTheme), disabled: _getDisableStatus(field, dataItem), onChange: (e) => {
                    const brand = e.target.value;
                    const newDataItem = Object.assign(Object.assign({}, dataItem), { brand1_name: field === 'brand1_name' ? brand.name : dataItem.brand1_name, brand2_name: field === 'brand2_name' ? brand.name : dataItem.brand2_name, brand3_name: field === 'brand3_name' ? brand.name : dataItem.brand3_name, brand4_name: field === 'brand4_name' ? brand.name : dataItem.brand4_name, brand5_name: field === 'brand5_name' ? brand.name : dataItem.brand5_name, brand2_disable: field === 'brand1_name' ? false : dataItem.brand2_disable, brand3_disable: field === 'brand2_name' ? false : dataItem.brand3_disable, brand4_disable: field === 'brand3_name' ? false : dataItem.brand4_disable, brand5_disable: field === 'brand4_name' ? false : dataItem.brand5_disable, brand1_data: field === 'brand1_name' ? e.target.value : dataItem.brand1_data, brand2_data: field === 'brand2_name' ? e.target.value : dataItem.brand2_data, brand3_data: field === 'brand3_name' ? e.target.value : dataItem.brand3_data, brand4_data: field === 'brand4_name' ? e.target.value : dataItem.brand4_data, brand5_data: field === 'brand5_name' ? e.target.value : dataItem.brand5_data });
                    dispatch(stockpile_action_1.default.onClickMutation({
                        mutationMode: 'edit',
                        dataItem: newDataItem,
                    }));
                } }) }))) : ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `m_grid_cell_is_active_${dataIndex}` }, { children: field && rowData[field] })));
    };
    const columnsRender = actionColumn
        .concat(fullScreen ? stockpile_column_1.StockpileColumnPropsFullScreen : stockpile_column_1.StockpileColumnProps)
        .map((item) => {
        var _a;
        if ((_a = item.field) === null || _a === void 0 ? void 0 : _a.includes('brand')) {
            return Object.assign(Object.assign({}, item), { cell: customCellDropdown });
        }
        return item;
    });
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, title: 'Stockpile', isLoading: isLoading }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(stockpile_action_1.default.getDataGrid(dataStates));
                    dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, errorMessage: errorMessage, onClose: () => dispatch(stockpile_action_1.default.onCloseError()), style: { zIndex: 10 } }), (0, jsx_runtime_1.jsx)(grid_1.default, { editField: 'inEdit', style: stockpile_style_1.default.gridHeight, dataGrid: dataGrid, fullScreen: fullScreen, columns: columnsRender, dataStates: dataStates, pageable: true, sortable: true, sort: dataStates.sort, onPageChange: (v) => onDataStateChange('page', v), onTakeChange: (v) => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange })] }));
};
exports.default = StockpileConfiguration;
